import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class StorageService {
    constructor() {}

    set(key: string, value: any) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    get(key: string) {
        try {
            const value = localStorage.getItem(key);
            return value ? JSON.parse(value) ?? null : null;
        } catch (error) {
            console.error(`Error al recuperar el valor para la clave "${key}":`, error);
            return null;
        }
    }

    removeItem(key: string) {
        localStorage.removeItem(key);
    }

    clear() {
        localStorage.clear();
    }
}
